import { useState } from 'react'
import { Link } from 'react-router-dom'
import { formatKickoff, scorersFor } from './logic'
import { useHold } from './store'

export default function ScorerList() {
  const { team, season, nameOf } = useHold()
  const [openId, setOpenId] = useState(null)
  const [showSort, setShowSort] = useState(false)
  const rows = []
  if (season) {
    let place = 0
    scorersFor(season)
      .sort((a, b) => (
        b.goals - a.goals
        || a.played - b.played
        || nameOf(a.playerId).localeCompare(nameOf(b.playerId), 'da')
      ))
      .forEach((row, index, list) => {
        const previous = list[index - 1]
        const tied = previous && previous.goals === row.goals && previous.played === row.played
        if (!tied) place += 1
        rows.push({ ...row, place })
      })
  }

  if (!team || !season) return null

  return (
    <>
      <div className="hold-rank-help">
        <button
          type="button"
          className="hold-rank-help-button"
          aria-expanded={showSort}
          aria-label="Sådan sorteres listen"
          onClick={() => setShowSort((open) => !open)}
        >
          ?
        </button>
        {showSort ? (
          <p className="hold-note">
            Flest mål står øverst. Ved lige mange mål står færrest spillede kampe øverst. Er begge dele ens, deler spillerne placering, og den næste får nummeret lige efter. Navnet afgør kun rækkefølgen blandt dem, der deler.
          </p>
        ) : null}
      </div>
      {rows.length === 0 ? <p className="hold-empty">Ingen mål i sæsonen endnu.</p> : (
        <ol className="hold-rank">
          {rows.map((row) => (
            <li key={row.playerId} className={row.place <= 3 ? `is-place is-place-${row.place}` : ''}>
              <button type="button" onClick={() => setOpenId(openId === row.playerId ? null : row.playerId)}>
                <span className="hold-rank-place">{row.place}</span>
                <span className="hold-rank-name">{nameOf(row.playerId)}</span>
                <strong>{row.goals}</strong>
              </button>
              {openId === row.playerId ? (
                <ul className="hold-rank-matches">
                  {row.matches.map((match) => (
                    <li key={match.matchId}>
                      <Link to={`/hold/${team.id}/kamp/${match.matchId}`}>
                        {match.count} mod {match.opponent}
                        <span>{formatKickoff(match.kickoff)}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              ) : null}
            </li>
          ))}
        </ol>
      )}
    </>
  )
}
